import html from "./NextButton.html"

var module = angular.module("ResearchKitApplicationModule");

module.directive("nextButton",
	function () {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "=",
				"showCallback": "&?",
				"disabledCallback": "&?",
			},
			controller: ["$scope", function ($scope) {
				$scope.show = function () {
					if ($scope.showCallback) {
						return $scope.showCallback();
					} else {
						return true;
					}
				};

				$scope.disabled = function () {
					if ($scope.stepManager.surveyManager.getMode() == "Design") {
						return false;
					}

					if ($scope.disabledCallback) {
						return $scope.disabledCallback();
					} else {
						return false;
					}
				};
			}]
		};
	}
);